// removed by extract-text-webpack-plugin
module.exports = {"main":"_29C-jpfb_2RKmTouG45K8i","box":"_1Uo0QbSUKj2SMWFR_kgmlD","body":"_1eCXVQ4lIBUua9CqoWemcN","filters":"_1fgIKSs4OBcvb3Excqbgpr","table":"_2hbJ2XhljRP1nuF5c3nYCC"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/History/Main/style.css
// module id = 1668
// module chunks = 85